export default __webpack_public_path__ + "static/media/S-Mutatapasi.7a713c1e.jpg";